import { useEffect, useState } from 'react';

const navItems = [
  { label: 'Features', href: '#features' },
  { label: 'Insights', href: '#insights' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-black/60 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 border border-white/15">
            <i className="ri-sun-line text-white text-lg"></i>
          </span>
          <span className="text-white text-xl tracking-tight" style={{ fontFamily: 'Pacifico, cursive' }}>
            Lumenix
          </span>
        </a>

        {/* Desktop center pill nav */}
        <nav className="hidden md:flex items-center gap-1 px-2 py-2 rounded-full bg-white/5 backdrop-blur-xl border border-white/10">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="px-5 py-2 text-sm text-white/70 hover:text-white rounded-full hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Right CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            className="px-5 py-2.5 rounded-full bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            Get Started
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-white/10 border border-white/15 text-white cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
          <nav className="px-6 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-4 py-3 text-sm text-white/80 hover:text-white hover:bg-white/5 rounded-lg cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-2 px-4 py-3 rounded-full bg-white text-black text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}